import React from "react";

export default function Pruebas() {
	return <div>Pruebas</div>;
}
